import { render, staticRenderFns } from "./LogoPortal.vue?vue&type=template&id=298ea524&"
import script from "./LogoPortal.vue?vue&type=script&lang=js&"
export * from "./LogoPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports